import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';

export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_LEVEL_PRIORITY: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private minLevel: LogLevel = environment.production ? 'warn' : 'debug';

  debug(message: string, ...data: unknown[]): void {
    this.log('debug', message, ...data);
  }

  info(message: string, ...data: unknown[]): void {
    this.log('info', message, ...data);
  }

  warn(message: string, ...data: unknown[]): void {
    this.log('warn', message, ...data);
  }

  error(message: string, ...data: unknown[]): void {
    this.log('error', message, ...data);
  }

  private log(level: LogLevel, message: string, ...data: unknown[]): void {
    if (LOG_LEVEL_PRIORITY[level] < LOG_LEVEL_PRIORITY[this.minLevel]) {
      return;
    }

    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] [${level.toUpperCase()}]`;

    switch (level) {
      case 'debug':
        console.debug(prefix, message, ...data);
        break;
      case 'info':
        console.info(prefix, message, ...data);
        break;
      case 'warn':
        console.warn(prefix, message, ...data);
        break;
      case 'error':
        console.error(prefix, message, ...data);
        break;
    }
  }
}
